import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { UserMenu } from './userMenu';
import LanguageMenu from './languageMenu';
import BalderHeader, { LogoWrapperProps } from './balderHeader';

const LogoLinkWrapper = ({ children, className }: LogoWrapperProps) => (
  <Link to="/" className={className}>
    {children}
  </Link>
);

export const PageHeader: FC = () => {
  return (
    <BalderHeader title="Energimerkesystemet" logoWrapper={LogoLinkWrapper}>
      <BalderHeader.RightContent>
        <LanguageMenu />
        <UserMenu />
      </BalderHeader.RightContent>
    </BalderHeader>
  );
};
